export enum DynamicBannerAlertType {
  ARBITRATION_CASE = 'ARBITRATION_CASE',
}

export interface DynamicBannerAlertModel {
  type: DynamicBannerAlertType,
  alertContent: any;
}

export class DynamicBannerAlert implements DynamicBannerAlertModel {
  type: DynamicBannerAlertType;
  alertContent: any;

  constructor(input: Partial<DynamicBannerAlertModel >) {
    this.type = input.type;
    this.alertContent = input.alertContent;
  }
}
